import {isBrowser} from './helper'

/**
 * 设置lostorage
 * @param key key
 * @param value value
 */
export const setStorageItem = (key: string, value: any) => {
  try {
    const serializedValue = JSON.stringify(value)
    localStorage.setItem(key, serializedValue)
  } catch (error) {
    console.error('StorageUtil:set 序列化失败', error)
  }
}

/**
 * 获取localstorage
 * @param key key
 * @returns value
 */
export const getStorageItem = (key: string) => {
  if (!isBrowser()) return null
  try {
    const value = localStorage.getItem(key) || null
    if (value === null) return null
    try {
      return JSON.parse(value)
    } catch {
      return value
    }
  } catch (error) {
    console.error('StorageUtil:get 反序列化失败', error)
    return null
  }
}

export const removeStorageItem = (key: string) => {
  try {
    localStorage.removeItem(key)
  } catch (error) {
    console.error('StorageUtil:remove 失败', error)
  }
}
